/*=========================================================================================
  File Name: vuex.js
  Description: Vue State Management
==========================================================================================*/

import Vue from 'vue'
import Vuex from 'vuex'

// Register Vuex
Vue.use(Vuex)


/**
 * Modules
 * 
 */
import gameModule from './game/gameModule'
import betModule from './bet/betModule'

/**
 * Store Configuration
 * 
 * 
 */
export default new Vuex.Store({

    /**
     * Module Declarations
     * 
     */
    modules: {
        gameModule,  betModule
    }
})